import http from "../http-common";

export type UserLogoRequestRequest = {
    logo: string
}

const baseUrl = '/user-logo';

export const getLogoByUserId = () =>
    http.get<UserLogoRequestRequest>(`${baseUrl}`);

export const saveLogo = (logo: string) =>
    http.post<UserLogoRequestRequest>(`${baseUrl}`, { logo });

export const deleteLogoUser = () =>
    http.delete(`${baseUrl}`);

export const uploadLogoMultipart = (file: File) => {
    const formData = new FormData();
    formData.append('logo', file);

    return http.post(`${baseUrl}/upload`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
